import { AllAssetsSubCatagoryResponseModel, AssetsSubCatagoryDto, AssetsSubCatagoryResponse, AssetsSubCatagoryResponseModel, AssetsSubCatDropDownResponseModel, AssetSubCatDropDownDto } from '@gtpl/shared-models/asset-management';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { Raw } from 'typeorm';
import { AssetsCatagoryByIdDto } from './asset-catagory-id-request';
import { AssetsSubCatagory } from './assets-sub-catagory-entity';
import { AssetsSubRequest } from './dto/assets-sub-catagory-active-deactive';
import { AssetsSubCatagoryAdapter } from './dto/assets-sub-catagory-adpater';
import { AssetsSubCatagoryDTO } from './dto/assets-sub-catagory-dto';
import { AssetsSubCatagoryRepository } from './dto/assets-sub-catagory-repository';

@Injectable()
export class AssetsSubCatagoryService {

    constructor(private assetsRepository: AssetsSubCatagoryRepository, private assetsAdapter: AssetsSubCatagoryAdapter) {

    }

    async createAssetsSubCatagory(assetsSubCatagoryDTO: AssetsSubCatagoryDTO, isUpdate: boolean = false): Promise<AssetsSubCatagoryResponseModel> {
        try {
            console.log('assetsSubCatagoryDTO' + assetsSubCatagoryDTO.assetsCatagoryId);
            if (!isUpdate) {
                const assetsEntity = await this.getAssetsSubCatagoryWithoutRelations(assetsSubCatagoryDTO.assetsCatagoryId, assetsSubCatagoryDTO.assetsSubCatagoryName);
                if (assetsEntity) {
                    throw new ErrorResponse(11104, 'assetsSubCatagory already exists');
                }
            } else {
                const assetsEntity = await this.getAssetsSubCatagoryWithoutRelationsForUpdate(assetsSubCatagoryDTO.assetsSubCatagoryName, assetsSubCatagoryDTO.assetsSubCatagoryId);
                if (assetsEntity) {
                    if (assetsEntity.assetsSubCatagoryId != assetsSubCatagoryDTO.assetsSubCatagoryId) {
                        throw new ErrorResponse(11104, 'assetsSubCatagory already exists');
                    }
                }
            }
            const assetsEntity: AssetsSubCatagory = this.assetsAdapter.convertDtoToEntity(assetsSubCatagoryDTO, isUpdate);
            const savedAssetsSubCatagoryEntity: AssetsSubCatagory = await this.assetsRepository.save(assetsEntity);
            const savedAssetsCatagoryDto: AssetsSubCatagoryDTO = this.assetsAdapter.convertEntityToDto(savedAssetsSubCatagoryEntity);

            if (savedAssetsSubCatagoryEntity) {
                const response = new AssetsSubCatagoryResponseModel(true, isUpdate ? 11100 : 11101, isUpdate ? 'AssetsSubCatagory Updated Successfully' : 'AssetsSubCatagory Created Successfully', savedAssetsCatagoryDto);
                return response;
            } else {
                throw new ErrorResponse(11106, 'assetsSubCatagory saved but issue while transforming into DTO');
            }
        }
        catch (error) {
            throw error;
        }
    }

    async getAssetsSubCatagoryWithoutRelations(assetsCatagoryId: number, assetsSubCatagoryName: string): Promise<AssetsSubCatagory> {
        console.log(assetsCatagoryId, assetsSubCatagoryName);
        const response = await this.assetsRepository.findOne({
            where: { assetsCatagoryId: Raw(alias => `assets_catagory_id = '${assetsCatagoryId}'`), assetsSubCatagoryName: Raw(alias => `assets_sub_catagory_name = '${assetsSubCatagoryName}'`) },
        });
        console.log(response);
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async getAllAssetsSubCatagory(): Promise<AllAssetsSubCatagoryResponseModel> {
        try {
            const assetsDetails: AssetsSubCatagoryDTO[] = [];
            // retrieves all plants
            const assetsEntities: AssetsSubCatagory[] = await this.assetsRepository.find({
                relations: ['assetsCatagoryInfo'],

            });
            if (assetsEntities.length > 0) {
                assetsEntities.forEach(assetsEntities => {
                    const convertedAssetsDto: AssetsSubCatagoryDTO = this.assetsAdapter.convertEntityDetails(assetsEntities);
                    assetsDetails.push(convertedAssetsDto);
                });
                const response = new AllAssetsSubCatagoryResponseModel(true, 11208, "AssetsSubCatagory retrieved successfully", assetsDetails);
                return response;
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getRecordByAssetsClassificationId(id: number): Promise<AssetsSubCatagoryResponseModel> {
        const responseData = await this.assetsRepository.findOne({ where: { assetsClassificationId: id } });

        if (responseData) {
            const data = new AssetsSubCatagoryDto(responseData.assetsCatagoryId, responseData.assetsCatagoryInfo.assetsCatagoryName, responseData.assetsSubCatagoryName, responseData.createdUser, responseData.updatedUser, responseData.isActive, responseData.versionFlag, responseData.assetsSubCatagoryId);
            return new AssetsSubCatagoryResponseModel(true, 7879, 'Data Retrived Successfully', data);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }

    async getAssetsSubCatagoryWithoutRelationsForUpdate(assetsSubCatagoryName: String, id: number): Promise<AssetsSubCatagory> {
        const responseCode = await this.assetsRepository.findOne({
            where: { assetsSubCatagoryName: assetsSubCatagoryName },
        });
        if (responseCode || responseCode) {
            if (responseCode && responseCode) {
                if (responseCode.assetsSubCatagoryId == responseCode.assetsSubCatagoryId) {
                    return responseCode;
                }
                else if (responseCode.assetsSubCatagoryId == id) {
                    return responseCode;
                }
                else if (responseCode.assetsSubCatagoryId == id) {
                    return responseCode;
                }
                else {
                    return responseCode;
                }
            }
            else if (responseCode && !responseCode) {
                return responseCode;
            }
            else if (responseCode && !responseCode) {
                return responseCode;
            }
        } else {
            return null;
        }
    }

    async getAssetsSubCatagoryData(assetsCatagoryId: number): Promise<AssetsSubCatagory> {
        //  console.log(employeeId);
        const response = await this.assetsRepository.findOne({
            where: { assetsCatagoryId: assetsCatagoryId },
        });

        if (response) {
            return response;
        } else {
            return null;


        }
    }

    async activateorDeactivateAssets(assetsSubRequest: AssetsSubRequest): Promise<AssetsSubCatagoryResponse> {
        try {
            const assetsExists = await this.getAssetsSubCatagoryData(assetsSubRequest.assetsSubCatagoryId);
            if (assetsExists) {
                if (assetsSubRequest.versionFlag !== assetsExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current AssetsSubClassification information.Refresh and try again');
                } else {

                    const assetsSatatus = await this.assetsRepository.update(
                        { assetsSubCatagoryId: assetsSubRequest.assetsSubCatagoryId },
                        { isActive: assetsSubRequest.isActive, updatedUser: assetsSubRequest.updatedUser });
                    const updatedRecord = await this.getRecordByAssetsClassificationId(assetsSubRequest.assetsSubCatagoryId);
                    if (assetsExists.isActive) {
                        if (assetsSatatus.affected) {
                            const assetsResponse: AssetsSubCatagoryResponse = new AssetsSubCatagoryResponse(true, 10115, 'AssetsSubClassification is de-activated successfully');
                            return assetsResponse;
                        } else {
                            throw new ErrorResponse(10111, 'AssetsSubClassification is already deactivated');
                        }
                    } else {
                        if (assetsSatatus.affected) {
                            const assetcatResponse: AssetsSubCatagoryResponse = new AssetsSubCatagoryResponse(true, 10114, 'AssetsSubClassification is activated successfully');
                            return assetcatResponse;
                        } else {
                            throw new ErrorResponse(10112, 'assetsSubClassification is already  activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
    async getAssetsSubCatagoryForAssetsCatagoryId(assetsCatagoryByIdDto: AssetsCatagoryByIdDto): Promise<AssetsSubCatDropDownResponseModel> {
        try {

            const assets: AssetSubCatDropDownDto[] = [];
            const assetsEntities: AssetsSubCatagory[] = await this.assetsRepository.find({ where: { assetsCatagoryId: assetsCatagoryByIdDto.assetsCatagoryId, isActive: true } })

            console.log(assetsEntities);
            if (assetsEntities && assetsEntities.length > 0) {
                assetsEntities.forEach(assetsEntities => {
                    assets.push(new AssetSubCatDropDownDto(assetsEntities.assetsSubCatagoryId, assetsEntities.assetsSubCatagoryName));
                });
                const response = new AssetsSubCatDropDownResponseModel(true, 11108, "assets retrieved successfully", assets);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        } catch (err) {
            throw err;
        }
    }

}
